'use client'
import Welcome from '@/app/feature/welcome/page'

export default function Home() {
	return (
		<main>
			<Welcome />
		</main>
	)
}
